import {
  SEARCH_APPLICATIONS_SUCCESS,
  IS_APPLY_EDIT_APPLICATION,
  SEARCH_APPLICATIONS_FAILURE,
  SEARCH_APPLICATIONS_REQUEST,
  SET_ERROR_OCCURRED_WHILE_PERFORMING,
  GET_PROSPECT_OVERVIEW_SUCCESS,
  LOAD_MORE_SEARCH_APPLICATIONS,
  LOAD_MORE_SEARCH_APPLICATIONS_SUCCESS,
  LOAD_MORE_SEARCH_APPLICATIONS_FAILURE,
  SEARCH_USER_APPLICATIONS_REQUEST,
  GET_RO_PROSPECT_REQUEST_SUCCESS,
  UPDATE_RO,
  UPDATE_RO_SUCCESS,
  UPDATE_RO_FAILURE,
  RESET_SEARCH_RESULTS
} from "../actions/searchProspect";
import { LOGOUT } from "../actions/loginForm";
import { handleActions } from "../../utils/redux-utils";

export const initialState = {
  searchResults: [],
  isApplyEditApplication: null,
  isSearchLoading: false,
  errorCode: null,
  prospectOverview: {},
  prospectRO: {},
  searchError: false,
  searchErrorDesc: [],
  userApplicationsExist: false,
  roUpdating: false,
  roUpdateStatus: ""
};

export default handleActions(
  {
    [SEARCH_APPLICATIONS_REQUEST]: state => ({
      ...state,
      searchResults: initialState.searchResults,
      isSearchLoading: true,
      searchError: initialState.searchError,
      searchErrorDesc: initialState.searchErrorDesc
    }),
    [SEARCH_APPLICATIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      searchResults: payload || [],
      isSearchLoading: false
    }),
    [SEARCH_APPLICATIONS_FAILURE]: (state, { payload }) => ({
      ...state,
      searchResults: initialState.searchResults,
      isSearchLoading: false,
      searchError: payload.errorType ? true : false,
      searchErrorDesc: payload.errors ? payload.errors : []
    }),
    [SEARCH_USER_APPLICATIONS_REQUEST]: state => ({
      ...state,
      searchResults: initialState.searchResults,
      isSearchLoading: true,
      searchError: initialState.searchError,
      searchErrorDesc: initialState.searchErrorDesc
    }),
    [LOAD_MORE_SEARCH_APPLICATIONS]: state => ({
      ...state,
      //searchResults: initialState.searchResults,
      //isSearchLoading: true,
      //searchError: initialState.searchError,
      searchErrorDesc: initialState.searchErrorDesc
    }),
    [LOAD_MORE_SEARCH_APPLICATIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      searchResults: payload || [],
      isSearchLoading: false
    }),
    [LOAD_MORE_SEARCH_APPLICATIONS_FAILURE]: (state, { payload }) => ({
      ...state,
      searchResults: initialState.searchResults,
      isSearchLoading: false,
      searchError: payload.errorType ? true : false,
      searchErrorDesc: payload.errors ? payload.errors : []
    }),
    [IS_APPLY_EDIT_APPLICATION]: (state, { payload }) => ({
      ...state,
      isApplyEditApplication: payload
    }),
    [SET_ERROR_OCCURRED_WHILE_PERFORMING]: (state, { payload }) => ({
      ...state,
      errorCode: payload.errorCode
    }),
    [GET_PROSPECT_OVERVIEW_SUCCESS]: (state, { payload: { prospect } }) => ({
      ...state,
      prospectOverview: prospect
    }),
    [GET_RO_PROSPECT_REQUEST_SUCCESS]: (state, { payload }) => ({
      ...state,
      prospectRO: payload
    }),
    [UPDATE_RO]: (state, { payload }) => {
      return {
        ...state,
        roUpdating: true,
        roUpdateStatus: "",
        roUpdateType: payload.actionType ? payload.actionType : ""
      };
    },
    [UPDATE_RO_SUCCESS]: state => ({
      ...state,
      roUpdating: false,
      roUpdateStatus: true
    }),
    [UPDATE_RO_FAILURE]: state => ({
      ...state,
      roUpdating: false,
      roUpdateStatus: false
    }),
    [RESET_SEARCH_RESULTS]: state => ({
      ...state,
      searchResults: [],
      roUpdateStatus: ""
    }),
    [LOGOUT]: () => initialState
  },
  initialState
);
